import React from 'react';
import { useBannerAssets } from '@/shared/hooks/useBannerAssets';
import { PromoBanner } from '@/shared/ui/promo-banner';

export const CashbackBanner = () => {
  const bannerAssets = useBannerAssets('cashbackBanner');

  return (
    <PromoBanner
      bg={bannerAssets?.bg}
      mobile={bannerAssets?.mobile}
      overlay={bannerAssets?.overlay}
    />
  );
};
